module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_10_Aboriginal-Health-Council-SA@2x.7d713fa185d00b3671184352ac392588.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_10_Aboriginal-Health-Council-SA@2x.png
// module id = 772
// module chunks = 0